import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}


export const AiVoiceApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getVoice: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
      }
    >({
      query: ({ length, search, start }) => ({
        url: `${END_POINTS.aiVoice}?start=${start}&length=${length}` +
          (search?.length ? `&search=${search}` : ""),
        method: "GET",
      }),
    }),
    getVoiceById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getByIdVoice}${id}/`,
        method: "GET",
      }),
    }),
    addVoice: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.addVoice,
        method: "POST",
        body,
      }),
    }),
    updateVoice: builder.mutation<CommonResponseType, { body: any; id: number }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.aiVoiceupdate}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteVoice: builder.mutation<CommonResponseType, { id: number }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteVoice}${id}/`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
useAddVoiceMutation,
useLazyGetVoiceQuery,
useLazyGetVoiceByIdQuery,
useUpdateVoiceMutation,
useDeleteVoiceMutation,
} = AiVoiceApi;
